import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';

@Component({
  templateUrl: "./forbidden.component.html"
})
export class ForbiddenComponent implements OnInit, AfterViewInit {
  public pageTitle: string = 'Forbidden';
  constructor(private authService: AuthService, private appCommonService: AppCommonService) {
    this.appCommonService.pageContentAdditionalClass = "";
    this.appCommonService.pageName = this.pageTitle;
  }
  ngOnInit() {

  }

  ngAfterViewInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/users/forbidden.component.ts